import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { SolicitudesRuteoInfoFiltersDef } from "./SolicitudesRuteoInfoFiltersDef";

export const SolicitudesRuteoIcon = IconMailQuestion;
export const SolicitudesRuteoHelpText = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

export class SolicitudesRuteoInfoFilters extends Entity<SolicitudesRuteoInfoFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoInfoFiltersDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoInfoFiltersForm').then((module) => module.SolicitudesRuteoInfoFiltersForm);
        this.Title = "Solicitudes de Ruteo Filtros";
        this.HelpText = SolicitudesRuteoHelpText;
        this.Icon = SolicitudesRuteoIcon;
    }
}